import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: auto;
  max-width: 100%;
  height: 110px;
  padding: 0 47px 0 49px;
  h1 {
    flex-shrink: 0;
    margin: 0;
    font-size: 40px;
  }
`;

export const StyledTermsOfUseContentHeader = styled.div`
  height: 46px;
  margin-bottom: 35px;

  font-family: 'Work Sans', sans-serif;
  font-size: 34px;
  font-weight: bold;

  color: ${COLORS.usafaBlue};
`;

export const StyledTermsOfUseContentSubheader = styled.div`
  height: 33px;
  &:not(:nth-child(2)) {
    margin-top: 50px;
  }
  margin-bottom: 19px;

  font-family: 'Work Sans', sans-serif;
  font-size: 24px;
  font-weight: bold;

  color: ${COLORS.usafaBlue};
`;

export const StyledAccountButton = styled.div`
  @media (max-width: 1023px) {
    display: none;
  }
`;
